import Icon from '../assets'
import TextButton from '../ui-components/TextButton'

const Attachment = ({ filename, url, onDelete }) => <li class='content-attachments-list__item'>
  {
    url
      ? <a class='content-attachments-list__link' href={url}>{filename}</a>
      : <span class='content-attachments-list__text--loading'>{filename}</span>
  }
  {
    url
      ? <TextButton class='content-attachments-list__delete' onClick={onDelete}>
        <Icon width='18' height='18' icon='close' class='content-attachments__delete' />
      </TextButton>
      : <span style={{ width: '24px', position: 'relative' }}>
        <Icon icon='loader' />
      </span>
  }
</li>

export default Attachment
